import { getSessionStorage } from '@flex-packages/browser-storage';
import { BroadcastChannel } from 'broadcast-channel';
import { SESSION_CHANGE_MESSAGE } from './constants.mjs';

const AUTHORIZE_BROADCAST_CHANNEL_NAME = "__AUTH";
const AUTHORIZE_BROADCAST_MESSAGES = {
  AUTHORIZED: "__AUTHORIZED__",
  UNAUTHORIZED: "__UNAUTHORIZED__",
  TIMED_OUT: "__TIMED_OUT__",
  CHANGED: "__CHANGED__"
};
const LOGIN_PAGE_PATH = "/auth/login";
const HOME_PAGE_PATH = "/home";
function initAuthBroadcastChannel() {
  if (window.authorizeChannel) {
    return window.authorizeChannel;
  }
  window.authorizeChannel = new BroadcastChannel(AUTHORIZE_BROADCAST_CHANNEL_NAME);
  window.authorizeChannel.onmessage = (e) => {
    const isAlreadyOnLoginPage = window.location.pathname.indexOf(LOGIN_PAGE_PATH) !== -1;
    const isAlreadyOnHomePage = window.location.pathname.indexOf(HOME_PAGE_PATH) !== -1;
    const sessionStorage = getSessionStorage({
      namespace: "auth"
    });
    switch (e.type) {
      case AUTHORIZE_BROADCAST_MESSAGES.AUTHORIZED: {
        window.location.reload();
        break;
      }
      case AUTHORIZE_BROADCAST_MESSAGES.TIMED_OUT: {
        if (isAlreadyOnLoginPage) {
          break;
        }
        sessionStorage?.setItem(SESSION_CHANGE_MESSAGE.KEY, {
          type: SESSION_CHANGE_MESSAGE.TIMEOUT
        });
        break;
      }
      case AUTHORIZE_BROADCAST_MESSAGES.UNAUTHORIZED: {
        if (isAlreadyOnLoginPage) {
          break;
        }
        if (sessionStorage?.getItem(SESSION_CHANGE_MESSAGE.KEY)) return;
        sessionStorage?.setItem(
          SESSION_CHANGE_MESSAGE.KEY,
          { type: SESSION_CHANGE_MESSAGE.SIGN_OUT }
        );
        window.location.href = LOGIN_PAGE_PATH;
        break;
      }
      case AUTHORIZE_BROADCAST_MESSAGES.CHANGED: {
        const companyName = e.data;
        if (companyName) {
          sessionStorage?.setItem(SESSION_CHANGE_MESSAGE.KEY, {
            type: SESSION_CHANGE_MESSAGE.CHANGE_PREFIX,
            meta: { companyName }
          });
        }
        if (isAlreadyOnHomePage) {
          window.location.reload();
          break;
        }
        window.location.href = HOME_PAGE_PATH;
        break;
      }
    }
  };
  return window.authorizeChannel;
}
function broadcastAuthorizedMessage() {
  initAuthBroadcastChannel().postMessage({
    type: AUTHORIZE_BROADCAST_MESSAGES.AUTHORIZED
  });
}
function broadcastUnauthorizedMessage() {
  initAuthBroadcastChannel().postMessage({
    type: AUTHORIZE_BROADCAST_MESSAGES.UNAUTHORIZED
  });
}
function broadcastSessionTimedOutMessage() {
  initAuthBroadcastChannel().postMessage({
    type: AUTHORIZE_BROADCAST_MESSAGES.TIMED_OUT
  });
}
function broadcastChangedMessage(companyName) {
  initAuthBroadcastChannel().postMessage({
    type: AUTHORIZE_BROADCAST_MESSAGES.CHANGED,
    data: companyName
  });
}

export { broadcastAuthorizedMessage, broadcastChangedMessage, broadcastSessionTimedOutMessage, broadcastUnauthorizedMessage, initAuthBroadcastChannel };
//# sourceMappingURL=broadcast.mjs.map
